import { Broker, Language } from '../../models';

export enum LinkPartnershipType {
  IB = 1,
  Prime,
  Mlm,
  Master,
}

interface LinkSetupBroker {
  supportedLanguages: Language[];
}

export interface SubPartnershipLinkSetup {
  linkSetupBroker: LinkSetupBroker;
  countries: Country[];
  tradingAccountTypes: PlatformForLink[];
  linkConfigurations: LinkConfiguration[];
}

export interface MasterCode {
  accountTypeId: number;
  currency: string;
  masterCode: string;
}

export interface ClientLinkSetup {
  countries: Country[];
  tradingAccountTypes: PlatformForLink[];
  masterCodeConfigurations: MasterCode[];
  canCreateDefaultLink: boolean;
  hasCallCenter: boolean;
  linkSetupBroker: LinkSetupBroker;
}

export interface MlmLinkSetup {
  broker: Broker;
  linkConfigurations: LinkConfiguration[];
}

export interface ClientLinkDetails {
  id: string;
  shortCode: string;
  partnershipCode: string;
  language: string;
  brokerName: string;
  currency: string;
  platform: string;
  accountType: string;
  country: string;
  masterCode?: string;
  salesCode?: string;
  linkName: string;
  creationDate: Date;
  flowkey: string;
  linkType: number;
}

export interface ClientLink {
  brokerName: string;
  link: string;
  shortCode: string;
  language: string;
  isDefault: boolean;
  partnershipClientShortLinkDetails: ClientLinkDetails;
}

export interface PartnershipLinkDetails {
  shortCode: string;
  brokerName: string;
  language: string;
  schemeName: string;
  percentage: number;
  linkName: string;
}

export interface PartnershipLink {
  shortCode: string;
  brokerName: string;
  language: string;
  percentage: number;
  link: string;
  partnershipLinkDetails: PartnershipLinkDetails;
}

export interface Link {
  id?: 'string';
  creationDate?: 'string';
  type?: LinkPartnershipType;
  partnershipCode?: 'string';
  brokerName: string;
  link: string;
  shortCode: string;
  language: string;
  isDefault?: boolean;
  clicks?: number;
  registrationsCount?: number;
  registrationsPercentage?: number;
  fullKycCount?: number;
  fullKycPercentage?: number;
  firstTimeFundsInCount?: number;
  firstTimeFundsInPercentage?: number;
  startedTradingCount?: number;
  startedTradingPercentage?: number;
  tradingAccountsActiveCount?: number;
  tradingAccountsInactiveCount?: number;
  partnershipClientShortLinkDetails?: ClientLinkDetails;
  percentage?: number;
  partnershipLinkDetails?: PartnershipLinkDetails;
}

export interface Country {
  countryId: number;
  name: string;
  url: string;
}

export interface LinkConfiguration {
  id: number;
  partnershipCode: string;
  schemeFID: number;
  schemeName: string;
  publicSchemeName: string;
  percentage: 0;
}

export interface MasterIBDirectLink {
  id: number;
  partnershipCode: string;
  percentage: number;
}

export interface GeneratePartnerLinkRequestModel {
  shortCode?: string;
  currency?: string;
  partnershipCode: number | string;
  landingPage?: string;
  language: string;
  linkType: string;
  platform?: string;
  brokerFID: number;
}

export interface GeneratePartnerMasterLink {
  brokerId: number;
  shortCode: string;
  linkConfigurationId: string;
}

export interface LinkType {
  linkType: number | string;
  linkTypeText: string;
  currencies: string[];
}

export interface PlatformForLink {
  id: number | string;
  name: string;
  directCode: string;
  linkTypes: LinkType[];
}
